import { render, staticRenderFns } from "./ReportMatchViewData.vue?vue&type=template&id=3640c9aa&scoped=true&"
import script from "./ReportMatchViewData.vue?vue&type=script&lang=js&"
export * from "./ReportMatchViewData.vue?vue&type=script&lang=js&"
import style0 from "./ReportMatchViewData.vue?vue&type=style&index=0&id=3640c9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640c9aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
